import termsAndConditionsJson from './content/termsAndConditions.json';

export const termsAndConditionsMock = {
    layoutType: 2,
    data: {
        name: 'terms-and-conditions',
        areasList: [
            {
                id: 1,
                name: 'TermsAndConditions',
                componentName: 'Comp:TermsAndConditions',
                content: JSON.stringify(termsAndConditionsJson)
            }
        ]
    }
};
